import { render } from "./tubeFLTable.vue?vue&type=template&id=45d4e9c3"
import script from "./tubeFLTable.vue?vue&type=script&lang=js"
export * from "./tubeFLTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__